import React from 'react';
import { STUDENTS_VIEW, NavigationView } from './constants';
import { Box } from '@ublend-npm/aulaui-core';

const navItems: { key: NavigationView; label: string }[] = [
  {
    key: STUDENTS_VIEW,
    label: 'Students',
  },
];

const styles = {
  chip: {
    alignSelf: 'flex-start',
    bgcolor: 'action.selected',
    borderRadius: '18px',
    display: 'inline-flex',
    px: '12px',
    py: '6px',
    fontSize: '13px',
  },
};

const Navigation = () => {
  return (
    <Box sx={{ mt: '0.25rem' }}>
      {navItems?.map(({ key, label }) => {
        return (
          <Box key={key} sx={styles.chip}>
            {label}
          </Box>
        );
      })}
    </Box>
  );
};

export default React.memo(Navigation);
